export enum NewsTypeEnum {
    important = 'Важливо'
}